import { render } from "./EditSocialNetwork.vue?vue&type=template&id=26ebd36f"
import script from "./EditSocialNetwork.vue?vue&type=script&lang=js"
export * from "./EditSocialNetwork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__